// CB-CONV §3.4 on the client: an amount typed in dollars becomes integer cents by string arithmetic,
// never by multiplying a float. `12.10 * 100` is 1209.9999999999998 in JavaScript, and a form that
// rounds it has already made a decision the money rules say happens once, on the server.

/** "1,299.5" → "129950". Null when the text is not a non-negative amount with at most two decimals. */
export function dollarsToMinorUnits(text: string): string | null {
  const match = /^(\d+)(?:\.(\d{1,2}))?$/.exec(text.trim().replace(/[$,\s]/g, ''));
  if (!match) return null;
  const cents = (match[2] ?? '').padEnd(2, '0');
  return BigInt(`${match[1]}${cents}`).toString();
}

/** "129950" and "AUD" → "$1,299.50". Formats a string of minor units without passing through a float. */
export function formatMinorUnits(amountMinor: string, currency: string): string {
  const minor = BigInt(amountMinor);
  const whole = (minor / 100n).toLocaleString('en-AU');
  const cents = (minor % 100n).toString().padStart(2, '0');
  return `${currency === 'AUD' ? '$' : `${currency} `}${whole}.${cents}`;
}

/** "129950" → "1299.50": the form of an amount a person can edit, with no symbol or separators. */
export function minorUnitsToDollars(amountMinor: string): string {
  const minor = BigInt(amountMinor);
  return `${minor / 100n}.${(minor % 100n).toString().padStart(2, '0')}`;
}
